import { useTheme } from '@mui/material/styles';
import IconButton, { IconButtonProps } from '@mui/material/IconButton';
import { useMediaQuery } from '@mui/material';
import { useTranslation } from 'src/hooks/use-translation';

import { bgBlur } from 'src/theme/css';
import { useSettingsContext } from 'src/context/theme-settings-context';

import ArrowBackSvg from 'icons/monochrome/arrow-ios-back.svg';
import ArrowForwardSvg from 'icons/monochrome/arrow-ios-forward.svg';

import { NAV } from '../config-layout';

// ----------------------------------------------------------------------

export function NavToggleButton({ sx, ...other }: IconButtonProps) {
  const theme = useTheme();
  const settings = useSettingsContext();
  const { t } = useTranslation('', { keyPrefix: 'sidebar' });

  const lgUp = useMediaQuery(theme.breakpoints.up('lg'));

  if (!lgUp) {
    return null;
  }

  return (
    <IconButton
      size="small"
      aria-label={t(settings.themeLayout === 'default' ? 'collapse-nav' : 'expand-nav')}
      onClick={() =>
        settings.onUpdate('themeLayout', settings.themeLayout === 'default' ? 'mini' : 'default')
      }
      sx={{
        p: 0.5,
        top: 32,
        position: 'fixed',
        left: NAV.W_VERTICAL - 12,
        zIndex: theme.zIndex.appBar + 1,
        border: `dashed 1px ${theme.palette.divider}`,
        ...bgBlur({ opacity: 0.48, color: theme.palette.background.default }),
        '&:hover': {
          bgcolor: 'background.default',
        },
        ...sx,
      }}
      {...other}
    >
      {settings.themeLayout === 'default' ? (
        <ArrowBackSvg width={16} />
      ) : (
        <ArrowForwardSvg width={16} />
      )}
    </IconButton>
  );
}
